export const getServerUrl = (hostname?: string): string => {
  hostname = hostname || window?.location?.hostname || "";

  if (hostname.endsWith("zapier.com")) {
    return "https://zapier.com";
  }

  return "https://zapier-staging.com";
};
